import { render, staticRenderFns } from "./sassFees.vue?vue&type=template&id=dae3b7d8&scoped=true&"
import script from "./sassFees.vue?vue&type=script&lang=js&"
export * from "./sassFees.vue?vue&type=script&lang=js&"
import style0 from "./sassFees.vue?vue&type=style&index=0&id=dae3b7d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae3b7d8",
  null
  
)

export default component.exports